// Country / team mapping. Two views:
//   FLAG_BY_TEAM    → emoji (Apple/Linux/Android — Windows shows two letters)
//   ISO_BY_TEAM     → ISO 3166-1 alpha-2 (lowercase) for image rendering
//   <Flag team=…/>  → renders an actual PNG flag via flagcdn.com so it works
//                    on every platform.
export const FLAG_BY_TEAM = {
    "Mexico": "🇲🇽",
    "Zuid-Afrika": "🇿🇦",
    "Zuid-Korea": "🇰🇷",
    "Tsjechië": "🇨🇿",
    "Canada": "🇨🇦",
    "Bosnië en Herzegovina": "🇧🇦",
    "Verenigde Staten": "🇺🇸",
    "Paraguay": "🇵🇾",
    "Qatar": "🇶🇦",
    "Zwitserland": "🇨🇭",
    "Brazilië": "🇧🇷",
    "Marokko": "🇲🇦",
    "Haïti": "🇭🇹",
    "Schotland": "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    "Duitsland": "🇩🇪",
    "Curaçao": "🇨🇼",
    "Nederland": "🇳🇱",
    "Japan": "🇯🇵",
    "Ivoorkust": "🇨🇮",
    "Ecuador": "🇪🇨",
    "Zweden": "🇸🇪",
    "Tunesië": "🇹🇳",
    "Spanje": "🇪🇸",
    "Kaapverdië": "🇨🇻",
    "België": "🇧🇪",
    "Egypte": "🇪🇬",
    "Saoedi-Arabië": "🇸🇦",
    "Uruguay": "🇺🇾",
    "Iran": "🇮🇷",
    "Nieuw-Zeeland": "🇳🇿",
    "Frankrijk": "🇫🇷",
    "Senegal": "🇸🇳",
    "Irak": "🇮🇶",
    "Noorwegen": "🇳🇴",
    "Argentinië": "🇦🇷",
    "Algerije": "🇩🇿",
    "Oostenrijk": "🇦🇹",
    "Jordanië": "🇯🇴",
    "Portugal": "🇵🇹",
    "DR Congo": "🇨🇩",
    "Engeland": "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    "Kroatië": "🇭🇷",
    "Ghana": "🇬🇭",
    "Panama": "🇵🇦",
    "Oezbekistan": "🇺🇿",
    "Colombia": "🇨🇴",
    "Australië": "🇦🇺",
};
export const ISO_BY_TEAM = {
    "Mexico": "mx",
    "Zuid-Afrika": "za",
    "Zuid-Korea": "kr",
    "Tsjechië": "cz",
    "Canada": "ca",
    "Bosnië en Herzegovina": "ba",
    "Verenigde Staten": "us",
    "Paraguay": "py",
    "Qatar": "qa",
    "Zwitserland": "ch",
    "Brazilië": "br",
    "Marokko": "ma",
    "Haïti": "ht",
    "Schotland": "gb-sct",
    "Duitsland": "de",
    "Curaçao": "cw",
    "Nederland": "nl",
    "Japan": "jp",
    "Ivoorkust": "ci",
    "Ecuador": "ec",
    "Zweden": "se",
    "Tunesië": "tn",
    "Spanje": "es",
    "Kaapverdië": "cv",
    "België": "be",
    "Egypte": "eg",
    "Saoedi-Arabië": "sa",
    "Uruguay": "uy",
    "Iran": "ir",
    "Nieuw-Zeeland": "nz",
    "Frankrijk": "fr",
    "Senegal": "sn",
    "Irak": "iq",
    "Noorwegen": "no",
    "Argentinië": "ar",
    "Algerije": "dz",
    "Oostenrijk": "at",
    "Jordanië": "jo",
    "Portugal": "pt",
    "DR Congo": "cd",
    "Engeland": "gb-eng",
    "Kroatië": "hr",
    "Ghana": "gh",
    "Panama": "pa",
    "Oezbekistan": "uz",
    "Colombia": "co",
    "Australië": "au",
};
export function flagOf(team) {
    if (!team)
        return "⚽";
    return FLAG_BY_TEAM[team] ?? "⚽";
}
export function isoOf(team) {
    if (!team)
        return null;
    return ISO_BY_TEAM[team] ?? null;
}
